/**
 * Подпись окна «по завершённым суткам» (решение D1)
 * ==================================================
 *
 * «Сессии» и «Прогрессия» считаются только по ЗАВЕРШЁННЫМ суткам: сервер
 * обрезает конец окна вчерашним днём одинаково на живом и на роллапном пути
 * (server/src/services/rollups/coreRollup.ts). Пользователь при этом выбирает
 * пресеты, кончающиеся сегодня, поэтому виджет обязан сказать об обрезке
 * вслух — молча показанный укороченный период читается как баг данных.
 *
 * Нижняя граница окна тоже двигается: сервер поднимает начало до 2024-01-01 —
 * ровно той даты, с которой роллап вообще содержит события.
 *
 * ПОДПИСЬ НАЗЫВАЕТ ДАТЫ, А НЕ СЛОВО «ВЧЕРА». Границу считает сервер по своим
 * часам в UTC, а даты в пикере выбираются в местной зоне браузера: у команды
 * в UTC+3 ночью «вчера» сервера и «вчера» пользователя — разные дни, и слово
 * в подписи оказывалось бы неверным (см. шапку
 * server/src/services/rollups/coreRollup.ts). Дата — не оказывается.
 *
 * Ответ несёт dateRange = { start, end, requestedStart, requestedEnd,
 * capped, cappedStart, empty }.
 */

/**
 * Подпись периода для заголовка виджета.
 *
 * @param {string} prefix подпись оси окна («Период», «Когорта (регистрация)»)
 * @param {{start?: string, end?: string, requestedStart?: string, requestedEnd?: string, capped?: boolean, cappedStart?: boolean, empty?: boolean}} [dateRange]
 * @returns {string|null} строка подписи либо null, если окна ещё нет
 */
export function completedDaysSubtitle(prefix, dateRange) {
  if (!dateRange?.start) {
    return null;
  }

  if (dateRange.empty) {
    return `${prefix}: ${dateRange.requestedEnd || dateRange.start} — в окне нет завершённых суток (последние завершённые — по ${dateRange.end})`;
  }

  const notes = [];
  if (dateRange.capped) {
    notes.push(`конец окна — ${dateRange.end}: последний день неполный и не показывается`);
  }
  if (dateRange.cappedStart) {
    notes.push(`начало окна — ${dateRange.start}: раньше этой даты данных нет`);
  }

  const base = `${prefix}: ${dateRange.start} — ${dateRange.end}`;
  return notes.length > 0 ? `${base} · ${notes.join(' · ')}` : base;
}
